import cookies from 'js-cookie';

export const getCookieValue = (cookieName: string) => {
  return cookies.get(cookieName);
};
